import { defineMessages } from 'react-intl';

export default defineMessages({
  trialExpiredNotice: {
    id: 'app.containers.NonAuthenticatedAppLayout.trialExpiredNotice',
    defaultMessage:
      'Your free trial of Workpath has expired. To keep using Workpath, please contact sales@workpath.com.',
  },
  subscriptionExpiredNotice: {
    id: 'app.containers.NonAuthenticatedAppLayout.subscriptionExpiredNotice',
    defaultMessage:
      'Your subscription of Workpath has expired. To keep using Workpath, please contact sales@workpath.com.',
  },
  help: {
    id: 'app.containers.NonAuthenticatedAppLayout.help',
    defaultMessage: 'Help',
  },
  privacy: {
    id: 'app.containers.NonAuthenticatedAppLayout.privacy',
    defaultMessage: 'Privacy Policy',
  },
  secondaryContentTitle: {
    id: 'app.containers.NonAuthenticatedAppLayout.secondaryContentTitle',
    defaultMessage: 'Workpath Companion is here!',
  },
  secondaryContentDescription: {
    id: 'app.containers.NonAuthenticatedAppLayout.secondaryContentDescription',
    defaultMessage:
      "Draft better Goals, uncover dependencies, and surface risks in seconds. Acting as your copilot, Workpath's AI Companion brings feedback, alignment suggestions, and clear summaries to every team.",
  },
  secondaryContentCTA: {
    id: 'app.containers.NonAuthenticatedAppLayout.secondaryContentCTA',
    defaultMessage: 'Learn more about Workpath AI Companion',
  },
});
